// src/components/RequireRole.jsx
import { Navigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import { Box } from "@mui/material";

export default function RequireRole({ allowedRoles = [], children }) {
  const token = localStorage.getItem("accessToken");
  if (!token) return <Navigate to="/auth/login" />;

  try {
    const decoded = jwtDecode(token);
    const userRole = decoded.role || null;

    if (allowedRoles.length === 0 || allowedRoles.includes(userRole)) {
      return children;
    }

    return <Box p={2}>⛔ คุณไม่มีสิทธิ์เข้าถึงหน้านี้</Box>;
  } catch (e) {
    console.error("Token decode error:", e);
    return <Navigate to="/auth/login" />;
  }
}
